module.exports = __webpack_public_path__ + "static/viewRefresh-dc68e228d0f96047952ee5a6bad375c4.gif";